import React from 'react';
import HeaderNavigation from '../HeaderNavigation';
import { MainContentProps } from '.';

const MainContent: React.FC<MainContentProps> = ({
  children,
  user,
  menuList,
  classes,
  theme
}) => {
  return (
    <div className={`b-main-content ${classes || ''}`}>
      <HeaderNavigation theme={theme} user={user} menuList={menuList} />
      <main
        style={
          theme
            ? {
                backgroundColor: theme.colors.background
              }
            : {}
        }
      >
        {children}
      </main>
    </div>
  );
};

export default MainContent;
